<template>
  <video-boost-statistics mode="game"></video-boost-statistics>
</template>

<script>
import VideoBoostStatistics from './VideoBoostStatistics.vue'

export default {
  name: 'VideoBoostGameStats',
  components: {VideoBoostStatistics}
}
</script>
